<template>
  <v-btn text outlined @click="$router.push(route ? { name: route } : routeWithId)">
    <v-icon left>mdi-chevron-left</v-icon>
    {{ title }}
  </v-btn>
</template>
<script>
export default {
  props: {
    // Title of the route
    title: {
      type: String,
      default: '',
    },
    // Name of route
    route: {
      type: String,
      default: null,
    },
    routeWithId: {
      type: Object,
      default: () => {
        return {
          name: null,
          params: {
            id: '',
          },
        };
      },
    },
  },
};
</script>
